/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { camelCase } from 'lodash';

export type Ref = {
	getter: string;
	current: string;
};

export function getReactRef( querySelector: string ): Ref {
	const identifier = querySelector.slice( 1 );

	return {
		getter: camelCase( `${ identifier }-ref` ),
		current: camelCase( `${ identifier }-ref` ) + '.current'
	};
}
